/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

interface BvUnstyledLinkSignature {
  Args: {
    ariaDescribedBy?: string;
    ariaLabel?: string;
    external?: boolean;
    onClick?: (e: Event) => void;
    text?: string;
    url?: string;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLAnchorElement;
}

const BvUnstyledLinkComponent = templateOnlyComponent<BvUnstyledLinkSignature>();

export default BvUnstyledLinkComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvUnstyledLink: typeof BvUnstyledLinkComponent;
    'bv-unstyled-link': typeof BvUnstyledLinkComponent;
  }
}
